import api from "./axiosInstance";

// GET /dashboard/questionHeatmap?start=&end=&timezone=&bucket=
export async function getQuestionHeatmap(params) {
	const { start, end, timezone = "UTC", bucket = "hour_of_day" } = params || {};
	const { data } = await api.get("/dashboard/questionHeatmap", {
		params: { start, end, timezone, bucket }
	});
	return data;
}


